export default __webpack_public_path__ + "static/documents-system-a716c4e55488e2d770a4eebc5f261f97.png";